import { appendPrefillParams } from '@/utils/prefill';

export function convertHtmlToVueComponent(html, prefillable, frompath) {
  let newHtml = html;
  // for direct put internal link
  const regx = html.match(/<a[^>]*>([\s\S]*?)<\/a>/g);

  if (regx) {
    regx.forEach(anchor => {
      const hrefMatch = anchor.match(/href="(.*?)"/);
      if (!hrefMatch) return;

      const href = hrefMatch[1];
      if (href[0] === '/') {
        // Internal link - convert to router-link
        const replacedHtml = anchor
          .replace(/<a/g, '<router-link')
          .replace(/<\/a/g, '</router-link')
          .replace(/href="(.*?)"/g, 'to="$1"')
          .replace(/target="(.*?)"/g, '');

        newHtml = newHtml.replace(anchor, replacedHtml);
      }
      // External (http/https) links are handled in the DOM pass below — routed
      // through /url so they open in the in-app browser (or the system browser
      // when tagged gpc-external-browser).
    });
  }
  // handle prefillable
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = newHtml;

  const elements = tempDiv.querySelectorAll('[gpc-prefillable]');
  elements.forEach(link => {
    const href = link.getAttribute('href');
    // Internal links were already converted to <router-link to="..."> above, so
    // href can be null here — prefill only applies to external links.
    if (href === null) return;

    link.setAttribute('href', appendPrefillParams(href, prefillable));
  });

  // Route every remaining external (http/https) link through the in-app /url
  // redirect: it opens in the in-app browser (@capacitor/browser) and fires
  // analytics. Internal links are already <router-link>; mailto:/tel:/other
  // schemes are left untouched.
  //
  // Opt-out: links tagged gpc-external-browser are left as plain <a href> so
  // they open in the system browser (the pre-existing "link out" behaviour) —
  // NOT routed through /url.
  const externalLinks = tempDiv.querySelectorAll('a[href]');

  externalLinks.forEach(link => {
    const originalHref = link.getAttribute('href');

    // Skip if href is missing or empty
    if (!originalHref || originalHref.trim() === '') {
      console.warn('external link missing href attribute, skipping conversion');
      return;
    }

    // Only web links go through /url; leave mailto:, tel:, etc. as-is.
    if (!/^https?:\/\//i.test(originalHref.trim())) return;

    // gpc-external-browser opts the link out of in-app routing — leave the raw
    // <a href> so it opens in the system browser.
    if (link.hasAttribute('gpc-external-browser')) return;

    // Encode URL to handle special characters (matching InAppBrowser behavior)
    const encodedHref = encodeURIComponent(originalHref);
    const encodedFromPath = encodeURIComponent(frompath || '/');
    const modifiedHref = `/url?q=${encodedHref}&from=${encodedFromPath}`;

    const routerLink = document.createElement('router-link');

    // Copy all attributes except href and target (router-link doesn't support
    // target). Preserves data-event-tracking (Mixpanel autocapture) and any
    // gpc-* flags, and drops any target="_blank".
    Array.from(link.attributes).forEach(attr => {
      if (attr.name !== 'href' && attr.name !== 'target') {
        routerLink.setAttribute(attr.name, attr.value);
      }
    });

    routerLink.setAttribute('to', modifiedHref);
    routerLink.innerHTML = link.innerHTML;
    link.replaceWith(routerLink);
  });

  newHtml = tempDiv.innerHTML;

  return {
    template: newHtml,
  };
}
